// import core components
import { gsap } from "gsap/dist/gsap";

// import animations Type
import animationsProps from "@/interfaces/handleAnimations/handleAnimationsProps";

// import customeImage styles
import imageStyles from "@/elements/Shared/CustomImage/customimage.module.scss";

// import animationStyles
import {
  textsAnimations,
  scrollTriggerInit,
  handleAnimationStyle,
} from "@/utils/BlockTextImage/handleAnimations/modules";

export default async function handleAnimations({
  isHero,
  titleRef,
  buttonRef,
  isAnimated,
  sectionName,
  separatorRef,
  containerRef,
  isCircleAnimated,
  optionsAnimImages,
  containerImageRef,
  canAnimationBePaused,
  externalAnimations,
}: animationsProps) {
  // gsap utils array
  const circles = gsap.utils.toArray(`.${sectionName}-circle`);
  const images = gsap.utils.toArray(`.${sectionName}-image`);
  const textContentArray = gsap.utils.toArray("." + sectionName + "--contents");

  // declare const
  const smallHeroCircle = document.querySelector(`.${sectionName}-circle-1`);
  const bigHeroCircle = document.querySelector(`.${sectionName}-circle-2`);
  const numberOfTexts = textContentArray.length;
  const durationAnimations = 0.3;
  const textsAnimDelay = 0.1;
  const animStartDelay = isHero ? 0.2 : 0;

  // timeline
  const textTl = gsap.timeline({
    paused: true,
    duration: 0.3,
  });
  const circleTl = gsap.timeline({ paused: true, duration: 0.3 });
  const rotationTl = gsap.timeline({
    paused: true,
  });

  const imagesTl = gsap.timeline({
    paused: true,
    delay: animStartDelay + 0.2,
    duration: 0.5,
    // onStart: () => {
    //   if (externalAnimations) externalAnimations.externalAnimation.play();
    // },
  });
  const externSectionAnimTl = gsap.timeline();

  // if isAnimated is false return null
  if (!isAnimated) return null;

  // set to play on load if its hero
  if (isHero) {
    textTl.play();
    imagesTl.play();
  }

  //   Animations Block-images
  if (smallHeroCircle && bigHeroCircle && isHero) {
    circleTl
      .to(smallHeroCircle, {
        y: -10,
        yoyo: true,
        repeat: -1,
        duration: 1,
      })
      .to(bigHeroCircle, {
        rotate: -90,
        repeat: -1,
        yoyo: true,
        duration: 7.5,
      });
  }

  if (
    externalAnimations?.externalAnimation &&
    externalAnimations?.addTo !== "none"
  ) {
    externalAnimations.externalAnimation(externSectionAnimTl);
  } else if (
    externalAnimations?.externalAnimation &&
    externalAnimations?.addTo === "none"
  ) {
    externalAnimations?.externalAnimation(imagesTl);
  }

  // check which animation is needed and create the timeline animations
  if (optionsAnimImages) {
    handleAnimationStyle(
      optionsAnimImages,
      imagesTl,
      images,
      circles,
      circleTl,
      sectionName,
      isHero,
      imageStyles,
      isCircleAnimated,
      containerImageRef,
      rotationTl
    );
  }

  // Animations on block-texts
  textsAnimations(
    buttonRef,
    titleRef,
    textContentArray,
    animStartDelay,
    textsAnimDelay,
    separatorRef,
    durationAnimations,
    numberOfTexts,
    textTl
  );

  if (externalAnimations) {
    switch (externalAnimations.addTo) {
      case "textTl":
        textTl.add(externSectionAnimTl, "<+=0.3");
        break;
      case "imagesTl":
        imagesTl.add(externSectionAnimTl);
        break;
      case "none":
      default:
        break;
    }
  }

  scrollTriggerInit(
    sectionName,
    isHero,
    containerRef,
    textTl,
    imagesTl,
    rotationTl,
    canAnimationBePaused
  );
}
